import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";

export default function Supervisors() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    api.get("/employees", { params: { status: "active" } })
      .then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (r) => {
    try {
      const { data } = await api.patch(`/employees/${r.id}/preposto`, { is_preposto: !r.is_preposto });
      toast.success(data.is_preposto
        ? `${r.last_name} ${r.first_name} designato Preposto aziendale`
        : `${r.last_name} ${r.first_name} non è più Preposto`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const filtro = q.trim().toUpperCase();
  const lista = rows.filter((r) => !filtro
    || `${r.last_name} ${r.first_name} ${r.code}`.toUpperCase().includes(filtro));
  const preposti = rows.filter((r) => r.is_preposto);

  return (
    <div className="space-y-3" data-testid="supervisors-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-head font-bold tracking-tight">Preposti</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Designa i dipendenti con ruolo di Preposto aziendale: avranno accesso al Registro Emergenze
          dalla loro area riservata.
        </p>
      </div>

      <div className="rounded-sm border border-border bg-card p-3 flex flex-wrap items-center gap-2">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca dipendente..."
          className="h-9 w-[260px] rounded-sm" data-testid="supervisors-search" />
        <span className="text-xs text-muted-foreground" data-testid="supervisors-count">
          {preposti.length} preposti designati su {rows.length} dipendenti attivi
        </span>
      </div>

      <div className="rounded-sm border border-border bg-card overflow-x-auto scroll-thin">
        <table className="w-full text-sm" data-testid="supervisors-table">
          <thead className="bg-secondary"><tr>
            {[["Azioni", 180], ["Codice", 100], ["Dipendente", 240], ["Reparto", 200], ["Preposto", 120]]
              .map(([h, w]) => (
                <th key={h} style={{ width: w }}
                  className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap">{h}</th>
              ))}
          </tr></thead>
          <tbody>
            {lista.map((r) => (
              <tr key={r.id} className="border-t border-border hover:bg-secondary/40" data-testid={`supervisor-row-${r.code}`}>
                <td className="px-3 py-1.5">
                  <Button size="sm" variant={r.is_preposto ? "outline" : "default"}
                    className="h-8 rounded-sm font-semibold" data-testid={`supervisor-toggle-${r.code}`}
                    onClick={() => toggle(r)}>
                    {r.is_preposto ? "Revoca" : "Designa Preposto"}
                  </Button>
                </td>
                <td className="px-3 py-1.5 tabular-nums">{r.code}</td>
                <td className="px-3 py-1.5 font-semibold">{r.last_name} {r.first_name}</td>
                <td className="px-3 py-1.5">{r.department || "—"}</td>
                <td className="px-3 py-1.5">
                  {r.is_preposto ? (
                    <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded-sm bg-emerald-500/15 text-emerald-700 dark:text-emerald-300"
                      data-testid={`supervisor-badge-${r.code}`}>
                      <ShieldCheck size={12} /> PREPOSTO
                    </span>
                  ) : <span className="text-muted-foreground">—</span>}
                </td>
              </tr>
            ))}
            {lista.length === 0 && (
              <tr><td colSpan={5} className="px-3 py-8 text-center text-muted-foreground" data-testid="supervisors-empty">
                Nessun dipendente trovato
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
